import { useContext } from 'react';
import { invariant } from "./invariant.js";
import { IndexContext } from "./IndexContext.js";
export function useIndexContext() {
  var context = useContext(IndexContext);
  invariant(context !== null, 'The <Index> component must be used within <InstantSearch>.');
  return context;
}